import { useEffect, useState } from 'react';
import { API_URL } from './services/api.js';

export function getProfilePhotoUrl(profile) {
  const { photo, id } = profile || {};
  if (!photo || photo.kind === 'NONE') { return null; }
  if ((photo.kind === 'GOOGLE_URL' || photo.kind === 'GCS_FILE') && photo.url) {
    return photo.url;
  }
  if ((photo.kind === 'S3' || photo.kind === 'MONGODB_DATA') && id) {
    const baseUrl = API_URL.replace(/\/$/, '');
    const version = photo.version ? `?v=${encodeURIComponent(photo.version)}` : '';
    return `${baseUrl}/photos/${encodeURIComponent(id)}${version}`;
  }
  return null;
}

export default function ProfileAvatar({ profile, initials, className, style }) {
  const photoUrl = getProfilePhotoUrl(profile);
  const [photoFailed, setPhotoFailed] = useState(false);

  useEffect(() => { setPhotoFailed(false); }, [photoUrl]);

  return (
    <div
      data-profile-avatar
      className={`relative shrink-0 overflow-hidden rounded-full flex items-center justify-center font-semibold ${className || ''}`}
      style={style}
      aria-hidden="true"
    >
      {initials}
      {photoUrl && !photoFailed ? (
        <img
          src={photoUrl}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          onError={() => { setPhotoFailed(true); }}
        />
      ) : null}
    </div>
  );
}
